import { orderBy } from 'lodash';
import env from '@/config/env';
import DestaqueQuery from '@/graphql/tabela/queries/Destaque.gql';

export const Types = {
  LOADING: 'LOADING',
  DESTAQUE_ADD: 'DESTAQUE_ADD',
  DESTAQUE_CLEAR: 'DESTAQUE_CLEAR',
  DESTAQUE_ORDER: 'DESTAQUE_ORDER',
};

export default {
  namespaced: true,
  state: {
    loading: true,
    data: [],
  },
  getters: {
    loading: state => state.loading,
    data: state => state.data,
  },
  mutations: {
    [Types.LOADING](state, payload) {
      state.loading = payload.loading;
    },
    [Types.DESTAQUE_ADD](state, payload) {
      state.data = payload.data;
    },
    [Types.DESTAQUE_CLEAR](state) {
      state.data = [];
    },
    [Types.DESTAQUE_ORDER](state, payload) {
      const { data } = state;
      const order = orderBy(data, payload.order, payload.type);
      state.data = order;
    },
  },
  actions: {
    async getDestaques({ commit, dispatch }, { tabela, ufId }) {
      commit(Types.DESTAQUE_CLEAR);
      commit(Types.LOADING, { loading: true });
      try {
        const query = await env.tabela.query({
          query: DestaqueQuery,
          variables: {
            tabela,
            ufId: [ufId],
            // a tela inicial mostra sempre o valor à vista no PIX (parcela 0);
            // a UF vai junto porque o preço pode ser específico de DDD
            uf: ufId,
            paginate: 10,
            page: 1,
          },
          fetchPolicy: 'no-cache',
        });

        const { data } = query.data.destaques;
        // O valor do plano escolhido no cadastro substitui o preço padrão em
        // cel.preco, para ordenação e filtro de faixa seguirem no mesmo campo.
        const destaques = data.map(destaque =>
          destaque.precoPlano
            ? { ...destaque, cel: { ...destaque.cel, preco: destaque.precoPlano } }
            : destaque,
        );
        commit(Types.DESTAQUE_ADD, { data: destaques });
      } catch (e) {
        dispatch(
          'error/setError',
          { message: 'Não foi possível carregar os destaques' },
          { root: true },
        );
      } finally {
        commit(Types.LOADING, { loading: false });
      }
    },
    handleOrderBy({ commit }, payload) {
      // commit(Types.LOADING, { loading: true });
      commit(Types.DESTAQUE_ORDER, payload);
    },
  },
};
